import React from 'react'

export default function Element({ attributes, children, element }: Props) {
    switch (element.type) {
        case 'h3':
          return <h3 {...attributes}>{children}</h3>
        case 'h4':
          return <h4 {...attributes}>{children}</h4>
        case 'ul':
          return <ul {...attributes}>{children}</ul>
        case 'li':
          return <li {...attributes}>{children}</li>
        default:
          return <p {...attributes}>{children}</p>
    }
}

interface Props {
    children: React.ReactNode
    element: ElementInterface
    attributes: React.DetailedHTMLProps<React.HTMLAttributes<any>, any>
}

export type ElementInterface = 
    { type: 'p', children: TextInterface[] } |
    { type: 'h3', children: TextInterface[] } |
    { type: 'h4', children: TextInterface[] } |
    { type: 'li', children: TextInterface[] } |
    { type: 'ul', children: TextInterface[] }

export type TextInterface = { text: string }